// index.js
// 引入路由
import VueRouter from 'vue-router'

// 外壳 Layout 首屏必需，保持同步引入；其余页面改为懒加载，减小首屏 bundle
import Layout from "@/components/layout/Layout";
// 创建路由器
export default new VueRouter({
    mode: 'history',
    // 可以配置多个路由
    routes: [
        {
            // 用于连接路由器的路径
            path: '/',
            // 路由相关联的组件
            component: Layout,
            children: [
                {path: '/', component: () => import('@/views/Index'), meta: {titleKey: 'page_title.home', descKey: 'page_desc.home'}},
                {path: '/about', component: () => import('@/views/about/AboutUs.vue'), meta: {titleKey: 'page_title.about', descKey: 'page_desc.about'}},
                {path: '/download', component: () => import('@/views/download/Download.vue'), meta: {titleKey: 'page_title.download', descKey: 'page_desc.download'}},

                {path: '/news', component: () => import('@/views/news/News'), meta: {titleKey: 'page_title.news', descKey: 'page_desc.news'}},
                {path: '/news/detail', component: () => import('@/views/news/NewsDetail'), meta: {titleKey: 'page_title.news', descKey: 'page_desc.news'}},
                {path: '/productsType', component: () => import('@/views/products/ProductsTypeList.vue'), meta: {titleKey: 'page_title.products', descKey: 'page_desc.products'}},
                {path: '/productsType2', component: () => import('@/views/products/ProductsTwoTypeList.vue'), meta: {titleKey: 'page_title.products', descKey: 'page_desc.products'}},
                {path: '/productsType3', component: () => import('@/views/products/ProductsThreeTypeList.vue'), meta: {titleKey: 'page_title.products', descKey: 'page_desc.products'}},
                //产品列表
                {path: '/products', component: () => import('@/views/products/ProductsList.vue'), meta: {titleKey: 'page_title.products', descKey: 'page_desc.products'}},

                {path: '/products/detail', component: () => import('@/views/products/ProductsDetail.vue'), meta: {titleKey: 'page_title.products', descKey: 'page_desc.products'}},
                {path: '/concat', component: () => import('@/views/concat/Concat.vue'), meta: {titleKey: 'page_title.contact', descKey: 'page_desc.contact'}},
                // 404 兜底
                {path: '*', component: () => import('@/views/NotFound')}
            ]
        },
    ],
    // 路由切换后滚动到顶部（解决"首页滚到底、切换导航菜单仍停留在底部"问题）
    // 手机端 el-main 已改为 overflow:visible（整页滚动归 body）→ 滚动 window 即可；
    // PC 端 el-main 默认 overflow:auto 可能成为独立滚动容器，故同时兜底 main.scrollTop=0。
    // 用即时（非 smooth）以确保各端（含移动端 WebView）稳定回顶。
    scrollBehavior() {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
            const main = document.querySelector('.el-main');
            if (main) main.scrollTop = 0;
        }
        return {x: 0, y: 0};
    }
})

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(error => {
        if (error.name !== 'NavigationDuplicated') { // 屏蔽 push 相同路由的报错
            throw error;
        } else {
            console.warn(error.name);
        }
    });
}
